import { Navigate, useLocation } from 'react-router-dom';

const Flow = () => {
  const params = new URLSearchParams(useLocation().search);
  const path = params.get('path');
  const source = params.get('source');
  const port = params.get('port');

  try {
    if (source) localStorage.setItem('automationsDataSource', source);
    if (port) localStorage.setItem('automationsPort', port);
  } catch {}

  return <Navigate to={path ? `/automations?flow=${encodeURIComponent(path)}` : '/automations'} replace />;
};

export default Flow;
